import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useLazyUserQuery } from "shared/redux/endpoints/auth";
import {
  setTokens,
  setUser,
  setRole,
  setCentersFromUser,
} from "shared/redux/slices/authSlice";
import { RoleLabel } from "constant/Role";

export default function GoogleSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [trigger] = useLazyUserQuery();

  useEffect(() => {
    const handleSSOLogin = async () => {
      const accessToken = searchParams.get("accessToken");
      const refreshToken = searchParams.get("refreshToken");

      if (!accessToken || !refreshToken) return;

      const role = JSON.parse(atob(accessToken.split(".")[1])).roles[0];

      dispatch(setTokens({ accessToken, refreshToken }));
      dispatch(setRole({ role: RoleLabel[role] || RoleLabel["ROLE_TEACHER"] }));

      const result = await trigger();

      dispatch(
        setUser({
          user: {
            ...result.data,
            avatar:
              result.data.avatar ??
              "https://demo-lesson.sgp1.digitaloceanspaces.com/ava.png",
          },
        })
      );
      dispatch(
        setCentersFromUser({
          centerId: result.data.centerId,
          centerIds: result.data.centerIds || [],
        })
      );

      // Navigate only after ALL state (including role) is committed to Redux,
      // so App.js reads the correct role when selecting routes.
      navigate("/");
    };

    handleSSOLogin();
  }, []);

  return <></>;
}
